import { parseJson } from '@js/utilities/response';
import { openRemoteModal } from '@js/utilities/remoteModal';

export const returnModelsController = () => {
    const oldModelRemoteContentElements = document.querySelectorAll('.js-remote-content-old-model');
    // const newModelRemoteContentElements = document.querySelectorAll('.js-remote-content-new-model');

    const selectOldModelElements = [...document.querySelectorAll('.js-select-old-model')].filter(
        (el) => !el.dataset.selectOldModelInitialized
    );

    const selectNewModelElements = [...document.querySelectorAll('.js-select-new-model')].filter(
        (el) => !el.dataset.selectNewModelInitialized
    );

    const newModelValueElement = document.querySelector('.js-new-model-value');

    selectOldModelElements.forEach((selectOldModelElement) => {
        selectOldModelElement.addEventListener('change', () => {
            const jsonContainer = selectOldModelElement.closest('[data-product-json]');

            const productData = JSON.parse(jsonContainer.dataset.productJson);

            window.dispatchEvent(
                new CustomEvent('old-model-set', {
                    detail: {
                        productId: selectOldModelElement.dataset.orderProductId,
                        productType: selectOldModelElement.dataset.orderProductType,
                        product: productData,
                    },
                })
            );

            // oldModelRemoteContentElements.forEach((el) => {
            //     // el.dataset.remoteContent = `${el.dataset.remoteContentPrepare}?order_product_id=${selectOldModelElement.dataset.orderProductId}`;
            //     // window.returnsFormData.serviceProductType =
            //     //     selectOldModelElement.dataset.orderProductType;
            //     // el.loadRemoteContent();
            // });
        });
        selectOldModelElement.dataset.selectOldModelInitialized = true;
    });

    selectNewModelElements.forEach((selectNewModelElement) => {
        selectNewModelElement.addEventListener('click', async (e) => {
            e.preventDefault();

            window.returnsFormData.newModel = newModelValueElement.value;

            const response = await fetch(
                `/api/issue/get_product_info_json?model=${newModelValueElement.value}`
            );
            const data = await parseJson(response);

            if (response.ok) {
                if (data.product.options) {
                    openRemoteModal(
                        `/ajax/modals/returns-configure-product?custom_data_json=${encodeURIComponent(
                            JSON.stringify({ product: data.product })
                        )}`,
                        {
                            modalTarget: '#modal-returns-configure-product',
                        }
                    );
                } else {
                    window.dispatchEvent(
                        new CustomEvent('configure-product-modal-closed', {
                            detail: {
                                data: {},
                            },
                        })
                    );
                }

                // newModelRemoteContentElements.forEach((el) => {
                //     el.innerHTML = data;
                // });
            } else {
                openRemoteModal(
                    `/ajax/modals/error/default?custom_data_json=${JSON.stringify({
                        ...data,
                        phraseContext: 'returns-models',
                    })}`
                );
            }
        });

        selectNewModelElement.dataset.selectNewModelInitialized = true;
    });

    // oldModelRemoteContentElements.forEach((el) => {
    //     el.loadRemoteContent();
    // });

    // newModelRemoteContentElements.forEach((el) => {
    //     el.loadRemoteContent();
    // });

    window.addEventListener('old-model-set', async (e) => {
        console.log('old-model-set');

        const response = await fetch(
            `/api/issue/get_order_product_info?order_product_id=${e.detail.productId}`
        );

        if (response.ok) {
            const html = await parseJson(response);

            oldModelRemoteContentElements.forEach((el) => {
                el.innerHTML = html;
            });
        }
    });
};
